<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M10.91 11h.98v10h-.98zM17.33 11h.98v10h-.98zM24.02 11H25v10h-.98zM7 11h2.52v10H7zM13.12 11h2.52v10h-2.52zM20.11 11h2.52v10h-2.52zM4 11a1 1 0 01-1-1V5a2 2 0 012-2h5a1 1 0 010 2H5v5a1 1 0 01-1 1zM28 11a1 1 0 01-1-1V5h-5a1 1 0 010-2h5a2 2 0 012 2v5a1 1 0 01-1 1zM29 27a2 2 0 01-2 2h-5a1 1 0 110-2h5v-5a1 1 0 012 0zM10 29H5a2 2 0 01-2-2v-5a1 1 0 012 0v5h5a1 1 0 110 2z"/></svg>